import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== "/login" && window.location.pathname !== "/change-password") {
      window.location.href = "/login";
    }
    if (error.response?.status === 403 && error.response?.data?.detail === "Password change required" && window.location.pathname !== "/change-password") {
      window.location.href = "/change-password";
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatError(detail) {
  if (!detail) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
